import { createAction } from "@reduxjs/toolkit";
import { LoginData } from "models/LoginData";

export const login = createAction<LoginData>("login");
export const checkIsLoggedIn = createAction("checkIsLoggedIn");
export const logOut = createAction("logOut");
